import { useCallback } from 'react';
import { useQuoteBuilderView } from '@paradigm/features/src/unified-rfqs/ui/grfq/quote-builder/view';
import SelectField from '#/components/UnifiedRfqs/components/SelectField';
import Tooltip from '@paradigm/design-system/src/components/Tooltip';
import { useTrackAction } from '@paradigm/features/src/analytics';

function QuoteTimerSelect() {
  const { timer } = useQuoteBuilderView();
  const label = (
    <div css="display: flex; align-items: center;">
      Time In Force
      <Tooltip
        id="timer-popover"
        css="margin-left: 2px"
        tooltipContent="Good till RFQ expires"
      />
    </div>
  );
  const trackAction = useTrackAction();
  const handleOnChange = useCallback(() => {
    trackAction('select time in force');
  }, [trackAction]);

  return (
    <SelectField
      label={label}
      options={timer.options}
      value={timer.selectedOption}
      onChange={handleOnChange}
    />
  );
}

export default QuoteTimerSelect;
